import api from '@/os/APIs/contractAPI';

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$contracts = api;
  },
};
